import * as angular from 'angular';
import {IController} from "angular";
import {FulfillmentStepModel} from "../../../fulfillment/models/fulfillment-step.model";
import {SplitService} from "../../../commons/services/split-service.service";
import {MissingItemModel} from "../../models/missing-item.model";
import * as _ from "lodash";
import {ServiceItem} from "../../../commons/models/service-item.model";

export class ServiceMissingItemsDialogViewComponent implements IController {

  packageItem: ServiceItem;
  missingItem: MissingItemModel;
  onReset: Function;
  onAddMissingItemData: Function;
  onRemoveMissingItemData: Function;
  onChangeMissingItemData: Function;

  public totalMissingItemsCount: number = 0;
  public totalItems: number = 0;

  constructor() {

  }

  $onInit() {
    this._setTotalMissingItemsCount();
    this.totalItems = this.totalMissingItemsCount + (this.packageItem.count || 0);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    this._setTotalMissingItemsCount();
  }

  private _setTotalMissingItemsCount() {
    this.totalMissingItemsCount = _.reduce(this.missingItem.dataList,  (sum,item) =>{
      return sum + (item.quantity || 0);
    }, 0);
  }

}

angular
  .module('bringoz.admin.deliveries')
  .component('serviceMissingItemsDialogView', {
    require: {
      form: '^form'
    },
    bindings: {
      packageItem: '<',
      missingItem: '<',
      onReset: '&',
      onAddMissingItemData: '&',
      onRemoveMissingItemData: '&',
      onChangeMissingItemData: '&'
    },
    template: require('./service-missing-items-dialog-view.html').default,
    controller: ServiceMissingItemsDialogViewComponent
  });
